exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 480px) {\r\n  .container-fluid,\r\n  .row {\r\n    padding: 0px;\r\n  }\r\n  .navbar-header {\r\n    margin: 0px;\r\n  }\r\n}\r\n\r\n@media (min-width: 480px) {\r\n  .padding {\r\n    padding-left: 230px;\r\n  }\r\n}\r\n\r\n.mar-right {\r\n  margin-right: 10px;\r\n}\r\n\r\n.note-style {\r\n  font-size: 12px;\r\n  color: #b3b3b3;\r\n  margin-left: 15px;\r\n}\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/closure/closure.component.css
// module id = ../../../../../src/app/closure/closure.component.css
// module chunks = 0